// extracted by mini-css-extract-plugin
export default {"modal":"modal-hGQR1","body":"body-rD7vD","bodyReport":"bodyReport-EJLbu"};